const bg = {
    actionAlready: "Още не сте се регистрирали? Влезте",
    actionExit: "Изход",
    actionLogin: "ВЛЕЗТЕ",
    actionRegister: "РЕГИСТРИРАЙТЕ СЕ",
    actionSave: "ЗАПАЗЕТЕ",
    actionStart: "НАЧАЛО",
    actionContinue: "ПРОДЪЛЖЕТЕ",
    actionReset: "НУЛИРАНЕ НА ОЦЕНКАТА",
    actionDoDiagnost: "ПОКАЖЕТЕ ДИАГНОЗАТИКАТА",
    actionYes: "Да",
    actionNo: "Не",
    actionNext: "НАПРЕД",
    actionBusinessCase: "ПОКАЖЕТЕ ДОБРИ ПРАКТИКИ НА КОМПАНИЯТА",
    actionBusinessCases: "ПОКАЖЕТЕ ДОБРИ ПРАКТИКИ НА КОМПАНИИТЕ",
    actionOpenUrl: "ОТВОРЕТЕ URL",
    actionFilter: "ФИЛТРИРАЙТЕ",

    /** HOME */
    msgHomeTitleOne: "Измерете и увеличете нивото на кръговата зрялост на вашата мебелна компания",
    msgHomeSubTitle: "Онлайн инструментът FurnCIRCLE оценява напредъка на вашата компания към кръговата зрялост въз основа на приложените стратегии за кръгов дизайн",

    msgHomeSection2: "Изискванията за кръговост се разширяват.</br>Готови ли сте?",
    msgHomeSection2Text: "<ul style='padding-left: 20px'><li>Отговорете на въпросите относно стратегиите за кръгов дизайн, които са в момента приложени във вашата компания.</li><li>Получете индекса на кръговата зрялост на вашата компания.</li><li>Идентифицирайте стратегии за дизайн и добри практики на компании, които да повишат нивото на вашата компания.</li><li>Научете от добрите практики на реални компании, за да продължите да подобрявате нивото на кръговата зрялост на вашата компания.</li></ul>",
    msgHomeSection3: "Партньори",
    msgHomeSection2Btn: "Започнете оценката си",
    msgHomeSection3Btn: "КОНТАКТ",

    /** HEADER */
    msgHeader1: "Стратегии за кръгов дизайн и добри практики",
    msgHeader4: "Вход",

    /** DRAWER */
    msgCompany: "КОМПАНИЯ",
    msgDrawer1: "1. Отговорете",
    msgDrawer2: "2. Оценете",
    msgDrawer3: "3. Подобрете",
    msgDrawer4: "Събиране на стратегии",
    msgDrawer6: "Настройки",
    msgDrawer7: "Изход",

    /** LOGIN */
    msgWelcome: "Добре дошли",
    msgWelcomeSubtitle: "Моля, влезте, за да продължите",

    /** REGISTER */
    msgGetStarted: "Започнете",
    msgGetStartedSubtitle: "Този инструмент за самооценка е безплатен и конфиденциален",

    msgFirstname: "Първо име",
    msgLastname: "Фамилия",
    msgEmail: "Имейл",
    msgPassword: "Парола",
    msgConfirmPassword: "Потвърдете паролата",
    msgCompanyUser: "Компания или потребителско име",

    msgNotRegister: "Още не сте се регистрирали? <b>Създайте акаунт тук</b>",
    msgAlreadyRegister: "Вече сте регистрирани? <b>Влезте тук</b>",

    /** HOME TOOL */
    msgClickImage: "Щракнете, за да разширите модела линейно срещу кръговия модел.",

    msgArea: "ОБЛАСТ",
    msgProgress: "ОТГОВОРЕНИ ВЪПРОСИ",

    msgAssessmentAreas: "Стратегии за кръгов дизайн и жизнен цикъл на продукта",
    msgAssessmentDesc: "Стратегиите за кръгов дизайн се прилагат по време на фазата на проектиране и разработка на продукти, въпреки че тяхното (положително) въздействие може да се прояви в една или повече по-късни фази от жизнения цикъл на продукта. Следователно, един начин за класифициране на стратегиите за кръгов дизайн е според етапа на жизнения цикъл, който те въздействат: проектиране, материали, производство, разпространение, използване и край на живота.<br/><br/><span style=\"font-weight:bold; font-size:16px;\">Моля, отговорете на всички въпроси за всеки блок или фаза от жизнения цикъл, определете нивото на вашата кръгова зрялост и планирайте своето подобрение и преход към по-кръгова икономика!</span>",

    msgAssessment: "Оценка на FurnCIRCLE",
    msgNotApply: "Отбележете всички отговори, които се отнасят до текущото кръгово представяне на вашата компания. Отговорите се запазват автоматично.",
    msgMarkImportant: "Отбележете като важно",
    msgComment: "Коментар",
    msgCommentHolder: "Можете да напишете тук всяка свързана информация или ваши коментари.",

    /** ANSWER */
    msgPerformance: "Оценка на доклада",
    msgPerformanceSubtitle: "Разгледайте индекса на кръговата зрялост на вашата компания и на всяка фаза от жизнения цикъл на продуктите ви.",
    msgCompanyLevel: "Индекс на кръговата зрялост на вашата компания (0%-100%)",
    msgBlockArea: "ФАЗА ОТ ЖИЗНЕНИЯ ЦИКЪЛ",
    msgBlockValues: "СТОЙНОСТИ",

    /** ASSESS */
    msgImprovement: "Доклад за подобрение",
    msgImprovementMainSubtitle: "Научете какво можете да направите, за да подобрите постоянно кръговостта на вашата компания. Знайте стратегиите за дизайн и добрите практики на компаниите, които да помогнат да издигнете компанията си на следващо ниво.</br></br>Фазите от жизнения цикъл и стратегиите за кръгов дизайн с етикет/кръг „червен“ имат ниво на представяне, което е равно на или по-малко от 25% от максималната си стойност и следователно могат да се считат за приоритет за подобрение на кръговостта на компанията. Фазите или стратегиите с етикет/кръг „оранжев“ имат ниво на представяне по-високо от 25% и по-малко от или равно на 75% и затова също е важно да се обърне внимание на тяхното подобрение. Фазите или стратегиите с етикет/кръг „зелен“ имат ниво на представяне по-високо от 75% и следователно са по-малко приоритетни за подобрение.",
    msgImprovementSubtitle: "Научете какво можете да направите, за да подобрите постоянно кръговостта на вашата компания. Знайте стратегиите за дизайн и добрите практики на компаниите, които да помогнат да издигнете компанията си на следващо ниво.",
    msgLifecyclePhases: "Фази на жизнен цикъл",
    msgLifecycleIndex: "Индекс на кръговост на фазата",
    msgActionsToImplement: "Действия за прилагане:",
    msgBaselineScore: "Моят основен резултат",
    msgBusinessCaseEmpty: "Честито! Вече сте приложили основните стратегии, включени в тази категория",

    msgCat1: "ИКОНОМИЧЕСКИ И ОРГАНИЗАЦИОННИ",
    msgCat2: "ОБЩЕСТВЕНИ",
    msgCat3: "ЕКОЛОГИЧНИ",

    /** STRATEGIES COLLECTION */
    msgStrategiesSubtitle: "Прегледайте и разгледайте цялата колекция от стратегии за кръгов дизайн и добри практики на компании от проекта FurnCIRCLE.",
    msgLifecyclePhase: "Фаза от жизнен цикъл",
    msgDifficulty: "Трудност на прилагане",
    msgBusinessDynamics: "Генериране или доставка на стойност",
    msgBusinessFactors: "Стойност на предложението / Разходи / Ползи",

    /** SETTINGS */
    msgUserInfo: "Потребителска информация",
    msgUserCredentials: "Потребителски данни",

    /** MODAL */
    msgAreSure: "Сигурни ли сте?",

    msgSuccess: "Данните са актуализирани успешно",
    msgDeleteSuccess: "Данните са изтрити успешно",

    /** ALT TEXT */
    msgSaveCommentAlt: "Запазете “Коментара.” Не е необходимо да запазвате отговорите на въпросите; те се запазват автоматично.",
    msgDifficultyAlt: "Този етикет показва трудността при прилагането на стратегията за кръгов дизайн.",
    msgBusinessBlockAlt: "Този етикет показва кой бизнес блок от модела CANVAS (Генериране на стойност или Доставка на стойност) е засегнат от прилагането на стратегията за кръгов дизайн.",
    msgImpactBlockAlt: "Този етикет показва кой блок на въздействие от модела CANVAS (Разходи, Ползи или Стойностно предложение) е засегнат от прилагането на стратегията за кръгов дизайн.",

    /** ERROR */
    errorOblData: "Попълнете всички задължителни полета",
    errorEmailFormat: "Грешка в имейл формата",
    errorUserIncorrect: "Невалиден имейл/парола",
    errorSend: "Грешка в комуникацията, моля изчакайте и опитайте отново по-късно",
    errorLength: "Превишен брой символи",
    errorPassSame: "Паролите не съвпадат",

    /** RECOVERY PASS */
    msgRecoveryPassword: "Възстановяване на парола",
    msgRecoveryPasswordSubtitle: "Моля, въведете своя имейл адрес, за да получите код за нулиране на паролата.",
    msgCode: "Код",
    msgNewPassword: "Нова парола",
    actionRequestCode: "ИСКАНЕ НА КОД",
    actionUpdate: "АКТУАЛИЗИРАНЕ",
    actionBack: "НАЗАД",
    msgForgetPassword: "Забравихте ли паролата си?",
    errorRecovery: "Грешка при възстановяване на паролата, моля проверете въведения код",

    /** FOOTER */
    msgFooterContact: "КОНТАКТ",

    msgFooterGr: "Финансирано от Европейския съюз. Мненията и възприятията изразени обаче са само на автора/ите и не отразяват непременно тези на Европейския съюз. Нито Европейският съюз, нито финансиращата институция не могат да бъдат държани отговорни за тях. Референция на споразумение и грант: SOCPL-2022-SOC-DIALOG-01 (Проект 101102389)",
    msgCopyright: "Авторско право&copy;2025 AMBIT. Всички права запазени",

    msgFooterLegal: "Правно уведомление",
    msgFooterPrivacy: "Поверителност",
    msgFooterCookies: "Политика за бисквитки",

    /** PROGRESS VALUES */
    msgProgress0: "Стратегии за кръгов дизайн",

    /** COMPANY SIZES */
    msgCompanySize: "Размер на компанията",
    msgCompanySize1: "По-малко от 10 служители",
    msgCompanySize2: "10-30 служители",
    msgCompanySize3: "30-50 служители",
    msgCompanySize4: "Повече от 50 служители",

    /** PRODUCT TYPES */
    msgProductType: "Тип продукти, които произвеждате",
    msgProductType1: "Тапицерия",
    msgProductType2: "Матраци",
    msgProductType3: "Основи за тапицерия, канапета, основи за легла",
    msgProductType4: "Подизпълнител (рамки, обработка, лакиране и др.)",
    msgProductType5: "Услуги (специализирана логистика и др.)",
    msgProductType6: "Мебели от плоскости (меламин, шперплат, лак и др.)",
    msgProductType7: "Дървени мебели",
    msgProductType8: "Столове",
    msgProductType9: "Офис мебели",
    msgProductType10: "Мебели за обществени пространства и употреба",
    msgProductType11: "Врати, прозорци и дървени изделия",
    msgProductType12: "Персонализирани съоръжения (магазини, библиотеки, ресторанти, професионални бизнеси и др.)",
    msgProductType13: "Осветление",
    msgProductType14: "Покрития и настилки",
    msgProductType15: "Текстил",
    msgProductType16: "Декорации",

    /* COUNTRIES */
    msgCountry: "Държава",
    msgAfghanistan: "Афганистан",
    msgAlbania: "Албания",
    msgAlgeria: "Алжир",
    msgAmericanSamoa: "Американска Самоа",
    msgAndorra: "Андора",
    msgAngola: "Ангола",
    msgAnguilla: "Ангила",
    msgAntarctica: "Антарктика",
    msgAntiguaandBarbuda: "Антигуа и Барбуда",
    msgArgentina: "Аржентина",
    msgArmenia: "Армения",
    msgAruba: "Аруба",
    msgAustralia: "Австралия",
    msgAustria: "Австрия",
    msgAzerbaijan: "Азербайджан",
    msgBahamas: "Бахамите",
    msgBahrain: "Бахрейн",
    msgBangladesh: "Бангладеш",
    msgBarbados: "Барбадос",
    msgBelarus: "Беларус",
    msgBelgium: "Белгия",
    msgBelize: "Белиз",
    msgBenin: "Бенин",
    msgBermuda: "Бермудски острови",
    msgBhutan: "Бутан",
    msgBolivia: "Боливия",
    msgBosniaHerzegovina: "Босна и Херцеговина",
    msgBotswana: "Ботсуана",
    msgBouvetIsland: "Остров Буве",
    msgBrazil: "Бразилия",
    msgBritishIndian: "Британска Индийска океанска територия",
    msgBrunei: "Бруней",
    msgBulgaria: "България",
    msgBurkinaFaso: "Буркина Фасо",
    msgBurundi: "Бурунди",
    msgCambodia: "Камбоджа",
    msgCameroon: "Камерун",
    msgCanada: "Канада",
    msgCapeVerde: "Кабо Верде",
    msgCaymanIslands: "Кайманови острови",
    msgCentralAfrican: "Централноафриканска република",
    msgChad: "Чад",
    msgChile: "Чили",
    msgChina: "Китай",
    msgChristmasIsland: "Остров Рождество",
    msgCocosIslands: "Острови Кокос (Кийлинг)",
    msgColombia: "Колумбия",
    msgComoros: "Коморски острови",
    msgCongo: "Конго",
    msgRepublicCongo: "Демократична република Конго",
    msgCookIslands: "Острови Кук",
    msgCostaRica: "Коста Рика",
    msgIvoryCoast: "Кот д'Ивоар",
    msgCroatia: "Хърватия",
    msgCuba: "Куба",
    msgCyprus: "Кипър",
    msgCzechRepublic: "Чешка република",
    msgDenmark: "Дания",
    msgDjibouti: "Джибути",
    msgDominica: "Доминика",
    msgDominicanRepublic: "Доминиканска република",
    msgEastTimor: "Източен Тимор",
    msgEcuador: "Еквадор",
    msgEgypt: "Египет",
    msgEngland: "Англия",
    msgElSalvador: "Ел Салвадор",
    msgEquatorialGuinea: "Екваториална Гвинея",
    msgEritrea: "Еритрея",
    msgEstonia: "Естония",
    msgEthiopia: "Етиопия",
    msgFalklandIslands: "Фолкландски острови",
    msgFaroeIslands: "Фарьорски острови",
    msgFijiIslands: "Фиджи",
    msgFinland: "Финландия",
    msgFrance: "Франция",
    msgFrenchGuiana: "Френска Гвиана",
    msgFrenchPolynesia: "Френска Полинезия",
    msgFrenchSouthern: "Френски Южни територии",
    msgGabon: "Габон",
    msgGambia: "Гамбия",
    msgGeorgia: "Грузия",
    msgGermany: "Германия",
    msgGhana: "Гана",
    msgGibraltar: "Гибралтар",
    msgGreece: "Гърция",
    msgGreenland: "Грьонландия",
    msgGrenada: "Гренада",
    msgGuadeloupe: "Гваделупа",
    msgGuam: "Гуам",
    msgGuatemala: "Гватемала",
    msgGuernsey: "Гърнси",
    msgGuinea: "Гвинея",
    msgGuineaBissau: "Гвинея-Бисау",
    msgGuyana: "Гаяна",
    msgHaiti: "Хаити",
    msgHeardMcDonald: "Остров Хърд и островите Макдоналд",
    msgHolySee: "Свещената столница (Ватикан)",
    msgHonduras: "Хондурас",
    msgHongKong: "Хонг Конг",
    msgHungary: "Унгария",
    msgIceland: "Исландия",
    msgIndia: "Индия",
    msgIndonesia: "Индонезия",
    msgIran: "Иран",
    msgIraq: "Ирак",
    msgIreland: "Ирландия",
    msgIsrael: "Израел",
    msgIsleMan: "Остров Ман",
    msgItaly: "Италия",
    msgJamaica: "Ямайка",
    msgJapan: "Япония",
    msgJersey: "Джърси",
    msgJordan: "Йордания",
    msgKazakhstan: "Казахстан",
    msgKenya: "Кения",
    msgKiribati: "Кирибати",
    msgKuwait: "Кувейт",
    msgKyrgyzstan: "Киргизстан",
    msgLaos: "Лаос",
    msgLatvia: "Латвия",
    msgLebanon: "Ливан",
    msgLesotho: "Лесото",
    msgLiberia: "Либерия",
    msgLibyanJamahiriya: "Либийска арабска джамахирия",
    msgLiechtenstein: "Лихтенщайн",
    msgLithuania: "Литва",
    msgLuxembourg: "Люксембург",
    msgMacao: "Макао",
    msgNorthMacedonia: "Северна Македония",
    msgMadagascar: "Мадагаскар",
    msgMalawi: "Малави",
    msgMalaysia: "Малайзия",
    msgMaldives: "Малдиви",
    msgMali: "Мали",
    msgMalta: "Малта",
    msgMarshallIslands: "Маршалови острови",
    msgMartinique: "Мартиника",
    msgMauritania: "Мавритания",
    msgMauritius: "Мавриций",
    msgMayotte: "Майот",
    msgMexico: "Мексико",
    msgMicronesia: "Микронезия, Федеративни щати на",
    msgMoldova: "Молдова",
    msgMonaco: "Монако",
    msgMongolia: "Монголия",
    msgMontserrat: "Монсерат",
    msgMontenegro: "Черна гора",
    msgMorocco: "Мароко",
    msgMozambique: "Мозамбик",
    msgMyanmar: "Мианмар",
    msgNamibia: "Намибия",
    msgNauru: "Науру",
    msgNepal: "Непал",
    msgNetherlands: "Нидерландия",
    msgNetherlandsAntilles: "Нидерландски Антили",
    msgNewCaledonia: "Нова Каледония",
    msgNewZealand: "Нова Зеландия",
    msgNicaragua: "Никарагуа",
    msgNiger: "Нигер",
    msgNigeria: "Нигерия",
    msgNiue: "Ниуе",
    msgNorfolkIsland: "Остров Норфолк",
    msgNorthKorea: "Северна Корея",
    msgNorthernIreland: "Северна Ирландия",
    msgNorthernMariana: "Северни Мариански острови",
    msgNorway: "Норвегия",
    msgOman: "Оман",
    msgPakistan: "Пакистан",
    msgPalau: "Палау",
    msgPalestine: "Палестина",
    msgPanama: "Панама",
    msgPapua: "Папуа Нова Гвинея",
    msgParaguay: "Парагвай",
    msgPeru: "Перу",
    msgPhilippines: "Филипини",
    msgPitcairn: "Питкерн",
    msgPoland: "Полша",
    msgPortugal: "Португалия",
    msgPuertoRico: "Пуерто Рико",
    msgQatar: "Катар",
    msgReunion: "Реюнион",
    msgRomania: "Румъния",
    msgRussianFederation: "Русия",
    msgRwanda: "Руанда",
    msgSaintHelena: "Света Елена",
    msgSaintKitts: "Сейнт Китс и Невис",
    msgSaintLucia: "Сейнт Лусия",
    msgSaintPierre: "Сейнт Пиер и Микелон",
    msgSaintVincent: "Сейнт Винсент и Гренадините",
    msgSamoa: "Самоа",
    msgSanMarino: "Сан Марино",
    msgSaoTome: "Сао Томе и Принсипе",
    msgSaudiArabia: "Саудитска Арабия",
    msgScotland: "Шотландия",
    msgSenegal: "Сенегал",
    msgSerbia: "Сърбия",
    msgSeychelles: "Сейшелски острови",
    msgSierraLeone: "Сиера Леоне",
    msgSingapore: "Сингапур",
    msgSlovakia: "Словакия",
    msgSlovenia: "Словения",
    msgSolomonIslands: "Соломонови острови",
    msgSomalia: "Сомалия",
    msgSouthAfrica: "Южна Африка",
    msgSouthSandwich: "Южна Джорджия и Южни Сандвичови острови",
    msgSouthKorea: "Южна Корея",
    msgSouthSudan: "Южен Судан",
    msgSpain: "Испания",
    msgSriLanka: "Шри Ланка",
    msgSudan: "Судан",
    msgSuriname: "Суринам",
    msgSvalbardJan: "Свальбард и Ян Майен",
    msgSwaziland: "Свазиленд",
    msgSweden: "Швеция",
    msgSwitzerland: "Швейцария",
    msgSyria: "Сирия",
    msgTajikistan: "Таджикистан",
    msgTanzania: "Танзания",
    msgThailand: "Тайланд",
    msgTimorLeste: "Източен Тимор",
    msgTogo: "Того",
    msgTokelau: "Токелау",
    msgTonga: "Тонга",
    msgTrinidadTobago: "Тринидад и Тобаго",
    msgTunisia: "Тунис",
    msgTurkey: "Турция",
    msgTurkmenistan: "Туркменистан",
    msgTurksCaicos: "Търкс и Кайкос",
    msgTuvalu: "Тувалу",
    msgUganda: "Уганда",
    msgUkraine: "Украйна",
    msgUnitedArabEmirates: "Обединени арабски емирства",
    msgUnitedKingdom: "Обединеното кралство",
    msgUnitedStates: "Съединените щати",
    msgUnitedStatesMinor: "Населени американски острови",
    msgUruguay: "Уругвай",
    msgUzbekistan: "Узбекистан",
    msgVanuatu: "Вануату",
    msgVenezuela: "Венецуела",
    msgVietnam: "Виетнам",
    msgVirginIslandsBritish: "Британски Вирджински острови",
    msgVirginIslandsUS: "Вирджински острови, САЩ",
    msgWales: "Уелс",
    msgWallisFutuna: "Уолис и Футуна",
    msgWesternSahara: "Западна Сахара",
    msgYemen: "Йемен",
    msgZambia: "Замбия",
    msgZimbabwe: "Зимбабве"
}

export default bg;